exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.imgurl {\n  width: 200px;\n  height: 400px;\n}\n", ""]);

// exports
